<div class="dro-capture-card" [class.preview]="preview">
  <div class="card-header-row">
    <div class="title">
      New reading
      <span class="meta-chip">{{ today }}@if (recorderName) { · {{ recorderName }}}</span>
    </div>
    @if (hasCumulative) {
      <div class="legend"><i class="fas fa-arrow-up cumulative-badge"></i> must be equal to or higher than the previous reading</div>
    }
  </div>

  <form class="fields" [formGroup]="formGroup" (ngSubmit)="save()">
    @for (field of fields; track field.fieldCode) {
      <div class="field" [class.wide]="field.dataType === dataTypes.text">
        <label class="field-label" [for]="'dro-' + field.fieldCode">
          @if (field.cumulative) {
            <i class="fas fa-arrow-up cumulative-badge"></i>
          }
          {{ field.label }}@if (field.required) {<span class="required">*</span>}
          @if (field.unit) {
            <span class="unit-caption">· {{ field.unit }}</span>
          }
        </label>
        <div class="input-wrap" [class.invalid]="showError(field)">
          <input class="form-control form-control-sm" type="text" autocomplete="off"
            [id]="'dro-' + field.fieldCode" [formControlName]="field.fieldCode"
            [attr.inputmode]="field.dataType === dataTypes.number ? 'decimal' : null"
            [attr.maxlength]="field.maxLength">
          @if (field.unit) {
            <span class="unit">{{ field.unit }}</span>
          }
        </div>
        @if (showError(field)) {
          <div class="field-error">{{ validation.errors[field.fieldCode] }}</div>
        } @else if (preview) {
          <div class="field-hint">{{ constraintSummary(field) }}</div>
        } @else if (field.dataType === dataTypes.number) {
          <div class="field-hint">
            Prev {{ previousText(field) }}
            @if (gain(field)) {
              <span class="gain">{{ gain(field) }}</span>
            }
          </div>
        }
      </div>
    }
  </form>

  <div class="card-footer-row">
    <div class="note">
      Stored against serial {{ serialNumber || '—' }}. One reading per serial per day; once saved it cannot be edited — only an admin can delete it.
    </div>
    <div class="actions">
      <button type="button" class="btn btn-sm btn-light border" [disabled]="preview || saving" (click)="clear()">Clear</button>
      <button type="button" class="btn btn-sm btn-success" [disabled]="preview || saving || !validation.valid" (click)="save()">
        @if (saving) {<i class="fas fa-spinner fa-spin me-1"></i>}Save reading
      </button>
    </div>
  </div>
</div>
